var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnifiedFinancialManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9854",
    "data-name": "Group 9854",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5619",
    "data-name": "Rectangle 5619",
    width: 492,
    height: 492,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5525",
    "data-name": "Rectangle 5525",
    width: 512,
    height: 512,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9982",
    "data-name": "Group 9982",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9981",
    "data-name": "Group 9981",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6759",
    "data-name": "Path 6759",
    d: "M246,0C381.866,0,492,110.134,492,246S381.866,492,246,492,0,381.866,0,246,110.134,0,246,0",
    fill: "#244277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6760",
    "data-name": "Path 6760",
    d: "M290.724,137.367c-3.19-9.717-19.1-9.578-21.23-14.153a101.777,101.777,0,0,0-14.153-33.743c7.437-19.623,11.39-20.5-4.649-36.195C234.9,37.811,234.9,42.3,215.316,49.463a146.694,146.694,0,0,0-35.645-15.506C175.571,23.576,174.882,13.982,161.7,13H143.214c-13.177.984-13.858,10.578-17.966,20.959A147.652,147.652,0,0,0,89.6,49.463C70.012,42.3,70,37.811,54.219,53.276c-16.088,15.8-12.079,16.457-4.641,36.195a101.66,101.66,0,0,0-14.145,33.743c-2.132,4.567-18.04,4.428-21.238,14.153a94.022,94.022,0,0,0,0,29.938c2.509,7.61,13.161,9.487,19.869,12.243A148.2,148.2,0,0,0,49.578,215.2c-7.167,19.59-11.66,19.59,3.8,35.375,15.8,16.088,16.466,12.079,36.195,4.649a101.861,101.861,0,0,0,33.759,14.153c4.051,1.853,5.248,17.515,12.513,20.68a84.768,84.768,0,0,0,31.595.541c7.61-2.5,9.487-13.161,12.251-19.869a146.106,146.106,0,0,0,35.645-15.506c19.737,7.429,20.451,11.455,36.244-4.649,15.465-15.8,10.98-15.8,3.813-35.375a101.921,101.921,0,0,0,14.153-33.743c2.124-4.567,18.04-4.428,21.222-14.153l1.091-5.715V143.05l-1.091-5.715M229.265,220.04a102.87,102.87,0,1,1,24.961-71.947,102.435,102.435,0,0,1-24.961,71.947",
    transform: "translate(93.569 93.586)",
    fill: "#4195c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6763",
    "data-name": "Path 6763",
    d: "M83.014,24.479a57.933,57.933,0,1,0,57.927,57.939A57.938,57.938,0,0,0,83.014,24.479M107.15,55.862H93.094a18.25,18.25,0,0,1,2.408,5.79h11.671V71.6H95.67A21.992,21.992,0,0,1,76.036,88.813c7.246,7.9,15,17.181,22.333,26.164l3.17,3.9H85.466l-.717-.851c-8.131-9.8-15.691-18.749-25.234-28.975l-.65-.683V78.621H66.93c4.827,0,12.6-.974,14.919-7.023H58.922V61.652H80.9a14.573,14.573,0,0,0-12.253-4.234H58.922v-11.5h48.273Z",
    transform: "translate(165.021 160.73)",
    fill: "#f5f5f6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnifiedFinancialManagement);
export default __webpack_public_path__ + "static/media/UnifiedFinancialManagement.f667a2f7b9e5093ed8262631f60fbdf8.svg";
export { ForwardRef as ReactComponent };